"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var _Styles = require("../utils/Styles");

var _TileContext = require("../context/TileContext");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  right: 12px;\n  top: 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  ", ";\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* class needed here due to styled-components 3 bug */\n  .private-tile + & {\n    margin-top: 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var compactTileContext = {
  compact: true
};
var spacedMixin = (0, _styledComponents.css)(_templateObject());

var Tile = _styledComponents.default.div.withConfig({
  displayName: "UITile__Tile",
  componentId: "sc-1ay7yt4-0"
})(_templateObject2(), (0, _Styles.setBorderRadius)(), _colors.OLAF, _colors.GREAT_WHITE, function (_ref) {
  var distance = _ref.distance;
  return distance && (0, _Styles.setDistance)(distance);
}, function (_ref2) {
  var distance = _ref2.distance;
  return !distance && spacedMixin;
});

var CloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "UITile__CloseButton",
  componentId: "sc-1ay7yt4-1"
})(_templateObject3());

var UITile =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UITile, _Component);

  function UITile() {
    (0, _classCallCheck2.default)(this, UITile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITile).apply(this, arguments));
  }

  (0, _createClass2.default)(UITile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          closeable = _this$props.closeable,
          compact = _this$props.compact,
          onClose = _this$props.onClose,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable", "compact", "onClose"]);
      return _react.default.createElement(_TileContext.TileContextProvider, {
        value: compact ? compactTileContext : _TileContext.defaultTileContext
      }, _react.default.createElement(Tile, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-tile', className)
      }), closeable ? _react.default.createElement(CloseButton, {
        color: _colors.FLINT,
        onClick: onClose,
        size: "small"
      }) : null, children));
    }
  }]);
  return UITile;
}(_react.Component);

UITile.displayName = 'UITile';
UITile.propTypes = {
  children: _propTypes.default.node.isRequired,
  closeable: _propTypes.default.bool.isRequired,
  compact: _propTypes.default.bool.isRequired,
  distance: _propTypes.default.oneOf(_Styles.DISTANCE_KEYS),
  onClose: _propTypes.default.func
};
UITile.defaultProps = {
  closeable: false,
  compact: false
};
var _default = UITile;
exports.default = _default;
module.exports = exports.default;